<template>
  <assistant-step :title="$t('heatingBuildingType.label')">
    <gc-form
      class="assistant-form"
      v-model="formValid"
      @submit.prevent="onNext()"
    >
      <gc-row>
        <gc-col cols="12">
          <assistant-steps-overview
            :steps="heatingSteps"
            :context="context"
            :current-step="currentStepIndex"
            show-labels
            show-navigation /></gc-col
      ></gc-row>
      <gc-row>
        <gc-col cols="12">
          <form-field
            :form-data="formData"
            field-name="buildingType"
            :step="heatingStep"
            :assistantContext="assistantContext" /></gc-col
      ></gc-row>
      <gc-row>
        <gc-col cols="12">
          <assistant-step-navigation
            :assistantContext="assistantContext"
            :step="heatingStep"
            :steps="heatingSteps"
            :valid="formValid"
            @prev="onPrev()"
            @next="onNext()" /></gc-col
      ></gc-row>
      <gc-row>
        <gc-col cols="12">
          <transition name="fade">
            <skip-message @skip="jumpToContactForm()" />
          </transition>
        </gc-col>
      </gc-row>
    </gc-form>
  </assistant-step>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api';
import {
  faArrowLeft,
  faArrowRight,
  faCheck,
} from '@fortawesome/pro-regular-svg-icons';
import AssistantStep from '@/components/AssistantStep.vue';
import AssistantStepNavigation from '@/components/AssistantStepNavigation.vue';
import AssistantStepsOverview from '@/components/AssistantStepsOverview.vue';
import { useBaseTransitions } from '@/lib/xstate/transitions';
import { getStepContext } from '@/lib/context';
import { stepComponentProps } from '@/lib/steps/helper';
import GcForm from '@/components/primitives/GcForm.vue';
import GcRow from '@/components/primitives/GcRow.vue';
import GcCol from '@/components/primitives/GcCol.vue';
import FormField from '@/components/FormField.vue';
import GcButton from '@/components/primitives/GcButton.vue';
import { StepId } from '~/consts/assistant-steps';
import heatingSteps from '~/steps/heating/steps';
import SkipMessage from '@/components/SkipMessage.vue';
import { JUMP_TO_CONTACTFORM } from '~/consts/assistant-state-events';

export default defineComponent({
  components: {
    SkipMessage,
    GcForm,
    GcRow,
    GcCol,
    FormField,
    GcButton,
    AssistantStep,
    AssistantStepNavigation,
    AssistantStepsOverview,
  },
  props: {
    ...stepComponentProps,
  },
  setup: (props, { emit }) => {
    const formData = getStepContext(props.assistantContext, props.step);
    const formValid = ref(false);
    const { onPrev } = useBaseTransitions(
      emit,
      props.assistantContext,
      props.step,
    );
    const { onNext } = useBaseTransitions(
      emit,
      props.assistantContext,
      props.step,
    );

    const heatingStep = props.steps?.filter(
      (step) => step.id === StepId.HEATING_BUILDING_TYPE,
    )[0];
    const currentStepIndex = 5;

    const jumpToContactForm = (): void => {
      emit('transition', {
        event: JUMP_TO_CONTACTFORM,
      });
    };

    return {
      formData,
      formValid,
      StepId,
      onPrev,
      onNext,
      jumpToContactForm,
      faCheck,
      faArrowLeft,
      faArrowRight,
      heatingSteps,
      heatingStep,
      context: props.assistantContext,
      currentStepIndex,
    };
  },
});
</script>
